import { ref, watch } from 'vue';

/**
 * Preferência de marketing (mkt_accepted_at), compartilhada pelos 3 lugares
 * que ligam/desligam a mesma coisa: o toggle "Notificações" do header V2, o
 * card "Quero receber atualizações" (Dados da conta) e o card de ofertas do
 * dashboard V2 — mesmo PATCH bff/users/self-mkt, mesmo otimista + revert no
 * catch, mesmos textos.
 */
export function useMarketingOptIn() {
  const { userAcceptsMarketing, fetchUserProfile } = useUserData();
  const { openToaster } = useLayoutStore();
  const { t } = useTexts();

  const isActive = ref(false);
  const isSaving = ref(false);

  watch(
    () => userAcceptsMarketing.value,
    (value) => {
      isActive.value = !!value;
    },
    { immediate: true },
  );

  async function setMarketing(next: boolean) {
    if (isSaving.value) return;

    isActive.value = next; // otimista; reverte no catch
    isSaving.value = true;

    const { ApiService } = useApiService();

    await ApiService.patch('bff/users/self-mkt', {
      mkt_accepted_at: next ? new Date().toISOString() : null,
    })
      .then(async () => {
        // só avisa ao desativar — ativar (aceitar ofertas, ligar
        // notificações) fica silencioso nos 3 lugares que usam este
        // composable.
        if (!next) {
          openToaster({
            message: t('account.updates_section.disable_success'),
            type: 'warning',
          });
        }
        await fetchUserProfile({ force: true });
      })
      .catch((err: any) => {
        isActive.value = !next;
        openToaster({
          message:
            err?.data?.message || t('account.updates_section.update_error'),
          type: 'error',
        });
      })
      .finally(() => {
        isSaving.value = false;
      });
  }

  function toggle() {
    setMarketing(!isActive.value);
  }

  return { isActive, isSaving, setMarketing, toggle };
}
